import {useState} from "react";

import {Rule} from "../model/types";
import {DEFAULT_RULE} from "../../../utils/constants";

export const useRobotManagementState = () => {
  const [editingRule, setEditingRule] = useState<Rule | null>(null);
  const [selectedId, setSelectedId] = useState<string>("");
  const [dialogContent, setDialogContent] = useState<string>("");
  const [searchTerm, setSearchTerm] = useState<string>("");

  const newRule = () => {
    setEditingRule(DEFAULT_RULE);
    setSelectedId("");
  };

  const clearEditor = () => {
    setSelectedId("");
    setEditingRule(null);
  };

  const updateEditingRule = (patch) => {
    setEditingRule({...editingRule, ...patch});
  };

  return {
    editingRule,
    selectedId,
    dialogContent,
    searchTerm,
    setEditingRule,
    setSelectedId,
    setDialogContent,
    setSearchTerm,
    newRule,
    clearEditor,
    updateEditingRule,
  };
};
